interface SponsorProps {
    name: string,
    image: string,
    website: string
}

export const Sponsor = ({ name, image, website }: SponsorProps) => {
    return (
        <a href={website} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", cursor: "pointer", textDecoration: "none", color: "inherit" }}>
            <img src={image} alt={`${name}-image`} style={{ maxWidth: 200 }}/>
            <div>{name}</div>
        </a>
    );
}